import { DefaultService } from '@/services/DefaultService';

export default class MarcaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(marca) {
        return this._http.post(`${this._env}/promotor/produto/marca`, marca, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id) {
        return this._http.get(`${this._env}/promotor/produto/marca/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    delete(id) {
        return this._http.delete(`${this._env}/promotor/produto/marca/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAll(page = 0, limit = 50, situacao = 2, ...param) {
        return this._http.get(encodeURI(`${this._env}/promotor/produto/marca.json?page=${page}&limit=${limit}&situacao=${situacao}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacao(motivofoto) {
        return this._http.post(`${this._env}/promotor/produto/marca/updatesituacao`, motivofoto, this._headers).then(res => {
                return res.body;
        }, err => {
                this.verifyError(err);
                throw new Error("Problems while jobs are loading");
        });
    }
}